var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInputError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Base"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.64851 1.01384C8.39479 0.550727 7.60576 0.550727 7.35204 1.01384L0.752374 13.0519C0.692965 13.1597 0.663513 13.2807 0.666886 13.4028C0.67026 13.525 0.706345 13.6442 0.771626 13.7489C0.836906 13.8536 0.929155 13.9401 1.03938 14.0002C1.14961 14.0602 1.27406 14.0916 1.40061 14.0914H14.5999C14.7264 14.0916 14.8508 14.0602 14.9609 14.0002C15.0711 13.9403 15.1633 13.8537 15.2285 13.7491C15.2937 13.6445 15.3297 13.5253 15.333 13.4033C15.3364 13.2812 15.3069 13.1604 15.2474 13.0526L8.64851 1.01384ZM8.73357 11.967H7.26698V10.5508H8.73357V11.967ZM7.26698 9.13454V5.59395H8.73357L8.73431 9.13454H7.26698Z",
    fill: "#CB0B0B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputError);
export default __webpack_public_path__ + "static/media/input_error.ac1d8fbf413ec23c9746a2be6bbc8875.svg";
export { ForwardRef as ReactComponent };